/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { appSyncGraphQLApi } from '../../app/smorgAppSyncGraphQLApi';
import { Meal } from '../../API';

export interface MealBasketItem {
  meal: Meal;
}

export interface EndUserShoppingState {
  mealBasketItems: Array<MealBasketItem>;
  selectedShoppingListID: string | null | undefined;
  shoppingListChangesPending: Record<string, boolean>;
}

const initialState: EndUserShoppingState = {
  mealBasketItems: [],
  selectedShoppingListID: null,
  shoppingListChangesPending: {},
};

export const endUserShoppingSlice = createSlice({
  name: 'endUserShopping',
  initialState,
  reducers: {
    mealsAddedToMealBasket: (state, action: PayloadAction<Array<Meal>>) => {
      const newMeals = action.payload;
      // eslint-disable-next-line no-restricted-syntax
      for (const newMeal of newMeals) {
        if (
          !state.mealBasketItems.some((item) => item.meal.id === newMeal.id)
        ) {
          state.mealBasketItems.push({ meal: newMeal });
        }
      }
    },
    mealsRemovedFromMealBasket: (
      state,
      action: PayloadAction<Array<string>>,
    ) => {
      const mealIDs = action.payload;
      state.mealBasketItems = state.mealBasketItems.filter(
        (item) => !mealIDs.includes(item.meal.id),
      );
    },
    mealBasketCleared: (state) => {
      state.mealBasketItems = [];
    },
    mealBasketSelectedShoppingListIDChanged: (
      state,
      action: PayloadAction<string>,
    ) => {
      const shoppingListID = action.payload;
      state.selectedShoppingListID = shoppingListID;
    },
    shoppingListIsPendingChanges: (state, action: PayloadAction<string>) => {
      const shoppingListID = action.payload;
      state.shoppingListChangesPending[shoppingListID] = true;
    },
    shoppingListHasFinishedChanges: (state, action: PayloadAction<string>) => {
      const shoppingListID = action.payload;
      delete state.shoppingListChangesPending[shoppingListID];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(appSyncGraphQLApi.util.resetApiState, (state) => {
      state.mealBasketItems = [];
      state.selectedShoppingListID = null;
      state.shoppingListChangesPending = {};
    });
  },
});

export const {
  mealsAddedToMealBasket,
  mealsRemovedFromMealBasket,
  mealBasketCleared,
  mealBasketSelectedShoppingListIDChanged,
  shoppingListIsPendingChanges,
  shoppingListHasFinishedChanges,
} = endUserShoppingSlice.actions;

export default endUserShoppingSlice.reducer;
